module.exports = __webpack_public_path__ + "static/deep-work-7f4cdf060d4d5425df1f48e5db5162b9.jpg";